import Vue from 'vue'

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('comma', function (value) {
  if (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return value
})


Vue.filter('percent', function (value, decimal = 2, unit = '%') {
  if (value) {
    return (Number(value) * 100).toFixed(decimal) + unit
  }
  return value;
})


Vue.filter('fixed', function (value, decimal = 2) {
  if (!value || `${value}` === '0') {
    return Number('0').toFixed(decimal)
  }
  return value.toFixed(decimal)
})

Vue.filter('date', function (value, format = 'yyyy-MM-dd') {
  if (!value) return ''
  return new Date(value).format(format)
})
